import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { FormsModule } from '@angular/forms';
import { DetailsViewComponent } from './components/details-view/details-view.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { RouterModule } from '@angular/router';
import { DataTableLayoutComponent } from './components/data-table-layout/data-table-layout.component';
import { LogoutComponent } from './components/logout.component';
import { CheckboxListComponent } from './components/checkbox-list/checkbox-list.component';
import { DisplayFieldComponent } from './components/display-field/display-field.component';
import { StringToNullAccessorDirective } from './directives/string-to-null-value-accessor.directive';
import { NotesDialogComponent } from './components/notes-dialog/notes-dialog.component';
@NgModule({
  declarations: [
    NotFoundComponent,
    DetailsViewComponent,
    ConfirmDialogComponent,
    FormFieldComponent,
    DataTableLayoutComponent,
    LogoutComponent,
    CheckboxListComponent,
    DisplayFieldComponent,
    StringToNullAccessorDirective,
    NotesDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  exports: [
    NotFoundComponent,
    DetailsViewComponent,
    ConfirmDialogComponent,
    FormFieldComponent,
    RouterModule,
    DataTableLayoutComponent,
    LogoutComponent,
    StringToNullAccessorDirective,
    NotesDialogComponent,
  ]
})
export class SharedModule { }


